<div class="horarios" *ngIf=" getSucursalesActivas else loading">
  <div class="container" >
    <div class="row noBorderRow ">
      <div class="col-3 SucursalItem" *ngFor="let item of data">
        <div class="iconSucursal">
          <i class="bi bi-geo-alt-fill"></i>
        </div>
        <div class="nameSucursal" >
          <p>{{ convertirPrimeraLetraMayuscula(item.sucursal_nombre_comercial) }}</p>
          <p>{{ convertirPrimeraLetraMayuscula(item.sucursal_direccion) }}</p>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #loading>
  <p>Cargando...</p>
</ng-template>
